<script lang="ts">
  import EmployerProfile from '../../../components/admin/employers/EmployerProfile.svelte';
  export let params: { id: string };
</script>

<EmployerProfile params={params} />

